import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

import Timeline, { TimelineDot, TimelineLine } from 'Components/Timeline';
import { formatDate } from 'Utils';
import {
    PROCESS_STATUSES,
    PROCESS_STATUS_CLASSES,
    RESULT_TYPE_STATUS,
    PROCESS_STATUS_IN_PROGRESS,
    RESULT_TYPE_PROCESS_STATUS,
    PROCESS_STATUS_REJECTED,
    PROCESS_STATUS_PUBLISHED,
    PHASE_NEW,
} from 'Constants';

export default class SubmissionTimeline extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        phasesList: PropTypes.array.isRequired,
        activePhase: PropTypes.number.isRequired,
        activeStatus: PropTypes.number.isRequired,
        completedPhases: PropTypes.array.isRequired,
        created: PropTypes.string.isRequired,
        updated: PropTypes.string.isRequired,
    };

    /**
     * Excluded phases
     *
     * @type {string[]}
     */
    static exclude = ['rejected'];

    /**
     * Render phases
     */
    renderPhases = () => {
        const { activePhase, activeStatus, phasesList, completedPhases, created, updated } = this.props;
        const phaseNew = phasesList.find(phase => phase.alias === PHASE_NEW);
        const phaseStatusMap = {
            [`${phaseNew ? phaseNew.id : 1}.${RESULT_TYPE_STATUS}`]: formatDate(created),
            [`${activePhase}.${RESULT_TYPE_PROCESS_STATUS}.${activeStatus}`]: formatDate(updated)
        };

        completedPhases.forEach(({ status_id, type, created_at }) => {
            if (!phaseStatusMap[`${status_id}.${type}`]) {
                phaseStatusMap[`${status_id}.${type}`] = formatDate(created_at);
            }
        });

        const progressKey = activeStatus !== PROCESS_STATUS_IN_PROGRESS ? `${activePhase}.${RESULT_TYPE_PROCESS_STATUS}.${activeStatus}` : '';

        return phasesList
            .filter(({ alias }) => this.constructor.exclude.indexOf(alias) === -1)
            .map(({ id, timeline_title }) => {
                const nextDot = activePhase + 1;
                const isNextDot = nextDot === id;
                const isPreviousDot = nextDot - id === 1;
                const phaseKey = `${id}.${RESULT_TYPE_STATUS}`;
                const className = isNextDot ? `submission-current-stage-${PROCESS_STATUS_CLASSES[activeStatus]}` :
                    (isPreviousDot ? `submission-current-stage-${PROCESS_STATUS_CLASSES[PROCESS_STATUS_IN_PROGRESS]}` : '');

                return (
                    <Fragment key={id}>
                        <TimelineDot
                            isCompleted={id < nextDot}
                            isActive={isNextDot}
                            isPreviousDot={isPreviousDot}
                            title={isNextDot && phaseStatusMap[progressKey]}
                            subtitle={isNextDot && PROCESS_STATUSES[activeStatus]}
                            className={className}
                            subtitleClassName={`submission-status-title-${PROCESS_STATUS_CLASSES[activeStatus]}`}
                            date={id <= nextDot ? (phaseStatusMap[phaseKey] ? phaseStatusMap[phaseKey] : phaseStatusMap[progressKey]) : null}
                            isRejected={activeStatus === PROCESS_STATUS_REJECTED}
                            isPublished={activeStatus === PROCESS_STATUS_PUBLISHED}
                        />
                        <TimelineLine
                            isActive={activePhase === id && activeStatus !== PROCESS_STATUS_REJECTED}
                            title={timeline_title}
                            //subtitle={formatTimeLimit(time_limit)}
                        />
                    </Fragment>
                );
            });
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { phasesList } = this.props;
        if (!phasesList || !phasesList.length) return null;

        return <Timeline>{this.renderPhases()}</Timeline>;
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/containers/SubmissionTimeline.jsx